/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6 breadcrumb-title">
            <h1>Topup</h1>
          </div>
          <div class="col-sm-6 breadcrumb-content">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'dashboard' }">Dashboard</router-link>
              </li>
              <li class="breadcrumb-item active">Topup</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="container-fluid">
        <div class="row">
          <span>
            <h5>Mobile Recharge</h5>
          </span>
        </div>
        <div class="row">

          <div class="col-md-4">
            <div class="package-box" v-on:click="navigate('GP')">
              <div class="package-box-img">
                <img src="../../../public/img/gp.jpeg" alt="package">
              </div>
              <h4>
                Grameenphone Topup
                <!-- <span>{{value.package}}</span> -->
              </h4>
            </div>

          </div>

          <div class="col-md-4">
            <div class="package-box" v-on:click="navigate('BL')">
              <div class="package-box-img">
                <img src="../../../public/img/bl.jpeg" alt="package">
              </div>
              <h4>
                Banglalink Topup
                <!-- <span>{{value.billDueDate}}</span> -->
              </h4>
            </div>
          </div>

          <div class="col-md-4">
            <div class="package-box" v-on:click="navigate('ROBI')">
              <div class="package-box-img">
                <img src="../../../public/img/robi.jpeg" alt="package">
              </div>
              <h4>
                Robi Topup

              </h4>
            </div>
          </div>

        </div>

        <div class="row">

          <div class="col-md-4">
            <div class="package-box" v-on:click="navigate('AT')">
              <div class="package-box-img">
                <img src="../../../public/img/airtel.png" alt="package">
              </div>
              <h4>
                Airtel Topup
              </h4>
            </div>
          </div>

          <div class="col-md-4">
            <div class="package-box" v-on:click="navigate('TL')">
              <div class="package-box-img">
                <img src="../../../public/img/teletalk.png" alt="package">
              </div>
              <h4>
                Teletalk Topup
              </h4>
            </div>
          </div>

          <div class="col-md-4">
            <div class="package-box" v-on:click="navigate('SK')">
              <div class="package-box-img">
                <img src="../../../public/img/skitto2.png" alt="package">
              </div>
              <h4>
                Skitto Topup
              </h4>
            </div>
          </div>

        </div>

      <!-- <div class="row">
              <span><h5>Electricity Bill Payment</h5></span>
            </div>

            <div class="row">
                <div class="col-md-4">
                    <div class="package-box"
                    >
                          <div class="package-box-img">
                              <img src="../../../public/img/breb.jpeg" alt="package">
                          </div>
                          <h4>
                            BREB Bill Payment
                          </h4>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="package-box"
                    >
                          <div class="package-box-img">
                              <img src="../../../public/img/desco.png" alt="package">
                          </div>
                          <h4>
                            Desco Bill Payment
                          </h4>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="package-box"
                    >
                          <div class="package-box-img">
                              <img src="../../../public/img/dpdc.png" alt="package">
                          </div>
                          <h4>
                            DPDC Bill Payment
                          </h4>
                    </div>
                </div>
              </div> -->

      </div>
    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>
  </div>
</template>

<style scoped>
div.closed {
  /* background: green; */
  background: #CAFFD6;
  color: #119A30;
}

div.pending {
  background: #FFE9DD;
  /* color: #119A30; */
}

div.open {
  background: #FFE9DD;
}

div.in-progress {
  background: #FFE9DD;
}

/* div.breadcrumb-title{
  width: 50% !important;
}
div.breadcrumb-content{
  width: 50% !important;
} */

div.package-box {
  cursor: pointer;
}

.package-box h4 {
  position: absolute;
  bottom: 10px;
  vertical-align: bottom;
}

.package-box-img {
  height: 132px;
  width: fit-content;
}

.package-box-img img {
  margin-top: 10px;
  width: 132px;
  height: 96px;
}
</style>
<script>

import VuePagination from '@/components/partials/PaginationComponent'
import SortIcons from '@/components/utils/SortIcons'
import axios from 'axios'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import { CommonAPI } from '@/services/api'
import { Notification } from 'element-ui'
import VueHighcharts from 'vue2-highcharts'
import localStorage from '@/services/localStorage';
const fileDownload = require('js-file-download')


export default {
  name: 'Topup',
  metaInfo: {
    title: 'Topup | Dotlines'
  },

  components: {
    DatePicker,
    VuePagination,
    SortIcons,
    VueHighcharts
  },

  data: () => ({

    value: {
      is_loading: true,
      package: '',
      monthlyAmount: '',
      availableBalance: '',
      billDueDate: ''
    },


    ticketList:
    {
      is_loading: true,
      total: 0,
      per_page: 3,
      from: 1,
      to: 0,
      data: []
    },

    list: {
      is_loading: true,
      total: 0,
      per_page: 3,
      from: 1,
      to: 0,
      data: [],
      tickets: []
    },
    order_by: 'asc',
    api_url: '',
    showFilter: false,
    filter: {},
    dateRange: '',
    pre: [],
    is_loading: false,
    has_permission: true
  }),
  // method is called after page load
  mounted: function () {
    localStorage.remove('stateData') // remove from localStorage previous saved topup data

    // if ( this.isMobile() ) {

    //   if( window.$(document).find('body').hasClass('sidebar-open') ){
    //     window.$(document).find('.push-menu-class').trigger('click');
    //   }

    //   //console.log("Is Mobile View")
    // }


    // this.getPackageInfo()
    // this.api_url = '/admin_users'
    //this.getUsageData()
    // this.getOrganization();
    this.$root.$on('sort-data', () => {
      this.$root.$emit('show-icon')
      //this.getUsageData()
    })
  },
  methods: {

    navigate(operator) {
      console.log("Operator:", operator)
      this.$router.push({ name: 'topup_payment', params: { 'operator': operator } })
    },

    customFormatter(date) {
      return moment(date).format('YYYY-MM-DD hh:mm:ss')
    },


    apiUsage(query = null) {
      return new Promise((resolve, reject) => {
        axios.get(this.api_url, {
          params: query
        }).then(response => {
          resolve(response.data)
        }).catch(error => {
          if (error.response.status === 403) {
            this.has_permission = false
          }
          reject(error)
        })
      })
    },

    resetFilter() {
      const query = Object.assign({}, this.$route.query)
      if (Object.keys(query).length > 0) {
        delete query.order_by
        delete query.order_key
        delete query.page
        // Object.keys(query).forEach((key) => delete query.key);
        this.$router.replace({ query })
      }
      this.filter = {}
      // this.getUsageData()
    }

  }
}
</script>
